import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { RootState } from "../../../../redux/store";

import { Helmet } from "react-helmet-async";
import pdfImages from "../../../../assets/images/pdf-file-icon.png";
import { useEffect, useMemo, useState } from "react";
import LoadNewsArticlesDetailsAds from "../../../../components/advertisement/load-news-articles-details-ads";
import { ArticleDetailsDetails } from "../../../../models/article-detaisls-model";
import LoadingComp from "../../../../components/re-usable/loading/loading";
import { renderToString, renderToStaticMarkup } from "react-dom/server"

const NewsArticleComponent = () => {
  const [isContentLoaded, setIsContentLoaded] = useState(false);
  const [isAdPlacementCalled, setIsAdPlacementCalled] = useState(false);

  const { ArticleDetailsData, ArticleDetaislLoading } = useSelector((state: RootState) => state.ArticleDetails);
  const tags = ArticleDetailsData[0]?.articleItems[0]?.documentTags && ArticleDetailsData[0]?.articleItems[0]?.documentTags.split(",");

  const [articleDetails, setArticleDetails] = useState<ArticleDetailsDetails | null>(ArticleDetailsData[0]?.articleItems[0] || null);
  const [articleDetailsString, setArticleDetailsString] = useState("");

  useEffect(() => {
    if (ArticleDetailsData[0]?.articleItems[0] && !isContentLoaded) {
      const htmlString = renderToStaticMarkup(<ArticleComponent {...ArticleDetailsData[0]?.articleItems[0]} />)
      let timeout = 1000;

      let article = "";
      article = placead("#adcontentbannersdiv .adunitcontent1", Math.max(2400, Math.floor(htmlString.length / 3)), htmlString) || htmlString;
      article = placead("#adcontentbannersdiv .adunitcontent2", 400 + Math.floor(article.length * (2 / 3)), article) || article;
      
      setArticleDetails(ArticleDetailsData[0]?.articleItems[0]);
      setArticleDetailsString(article);

      const category = $('.category-text').text();
      console.log(category);

      //gtag('event', 'article_page', {
      //  "article_category": category,
      //});
      
      setIsContentLoaded(true);
      setTimeout(() => {
        setIsAdPlacementCalled(true);
      }, timeout);

      setTimeout(() => {
        const script = document.createElement('script');
        script.setAttribute('async', '');
        script.setAttribute('class', 'instagram-embed-scripts');
        script.src = '//www.instagram.com/embed.js';
        script.onload = () => {
          window.instgrm.Embeds.process();
        }
        $("#article").append(script);
      }, timeout + 1000)

    } else if (ArticleDetailsData[0]?.articleItems[0] === undefined) {
      setArticleDetails(null);
    }
  }, [ArticleDetailsData]);

  const cachedNewsArticleAds = useMemo(() => <LoadNewsArticlesDetailsAds />, []);

  if (articleDetails === null) return <LoadingComp />

  return (
    <>
      <Helmet>
        <title>{articleDetails.menuItemName}</title>
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="RAPSorg" />
        <meta name="twitter:title" content={articleDetails.articleName} />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:title" content={articleDetails.articleName} />
        <meta property="og:description" content={articleDetails.articleTeaserText} />
        <meta name="description" content={articleDetails.articleTeaserText} />
        {articleDetails.articleImage && (
          <>
            <meta property="og:image" content={articleDetails.articleImage} />
            <meta name="twitter:image" content={articleDetails.articleImage} />
          </>
        )}
        {(!articleDetails.articleImage && articleDetails.articleTeaserImage)  && (
          <>
            <meta property="og:image" content={articleDetails.articleTeaserImage} />
            <meta name="twitter:image" content={articleDetails.articleTeaserImage} />
          </>
        )}
      </Helmet>
      {isAdPlacementCalled && cachedNewsArticleAds}

      <div className="article" id="article" dangerouslySetInnerHTML={{ __html: articleDetailsString }}></div>
      {tags && (
        <div className="TagCloud">
          <p>
            Tags:{" "}
            {tags?.map((item, index, { length }) => {
              return (
                <Link key={index} to={`/news-and-articles/news-articles?DocumentTags=${item.trim()}`}>
                  {`${item} ${index + 1 === length ? "" : ", "}`}
                </Link>
              );
            })}{" "}
          </p>
        </div>
      )}
    </>
  );
};

export default NewsArticleComponent;

const ArticleComponent = (articleDetails: ArticleDetailsDetails) => {
  return (
    <>
      <div className="article" id="article">
        <h1 className="black" style={{ marginTop: "0px" }} itemProp="headline">
          {articleDetails.articleName}
        </h1>
        {((articleDetails.category !== null || articleDetails.category !== "") && articleDetails.category.toString().includes("394")) || articleDetails.category.toString().includes("402") ? (
          <>
            <p className="small" style={{ marginTop: "15px" }}>
              {articleDetails.author.trim() !== "" && <span className="authors" dangerouslySetInnerHTML={{ __html: articleDetails.author }}></span>}
            </p>
            <p className="small" style={{ display: "inline-flex" }}>
              <span className="d-flex" dangerouslySetInnerHTML={{ __html: articleDetails.badgeUrl }}></span>&nbsp;|&nbsp;{articleDetails.articleReleaseDate}
              &nbsp;|&nbsp;
              <a href="#citation" style={{ fontSize: "medium" }}>
                Citation
              </a>
              {articleDetails.pdfLocation !== "" && (
                <>
                  &nbsp;|&nbsp;
                  <a href={articleDetails.pdfLocation} target="_blank">
                    <img style={{ width: "15px" }} alt="PDF Link" src={pdfImages} /> PDF
                  </a>
                </>
              )}
            </p>
          </>
        ) : (
          <p className="small" style={{ marginTop: "15px", display: "flex" }}>
            <span className="d-flex" dangerouslySetInnerHTML={{ __html: articleDetails.badgeUrl }}></span>&nbsp;|&nbsp;{articleDetails.articleReleaseDate}
            {articleDetails.author.trim() !== "" && (
              <>
                &nbsp;|&nbsp;<span className="authors" dangerouslySetInnerHTML={{ __html: articleDetails.author }}></span>
              </>
            )}
          </p>
        )}
        <div className="right-content">
          <div className="articleteaser text-right">{articleDetails.articleTeaserImage && <img itemProp="image" alt={articleDetails.articleName} src={articleDetails.articleTeaserImage} />}</div>
          <p className="small newscaption">{articleDetails.articleImageCaption}</p>
        </div>
        <div className="content" dangerouslySetInnerHTML={{ __html: articleDetails.articleText }}></div>
        <p>&nbsp;</p>© {new Date().getFullYear()}&nbsp;Regulatory Affairs Professionals Society.
        <hr />
      </div>
    </>
  );
};

const placead = (adunit: string, start: number, article: string) => {

  let articleElement = $(`<div>${article}</div>`);
  let content = $(articleElement).html();

  if (content.length > start + 400) {
    let mid = start + content.substring(start, content.length).indexOf("\n") + 1;
  
    let mid2 = start + content.substring(start, content.length).indexOf("</p>") + 4;
  
    mid = Math.min(mid, mid2);
  
    if (window.location.href.toString().includes('rf-quarterly-december-2022-artificial-intelligence') && adunit.includes('1')) {
      mid = 1200 + content.substring(start, content.length).indexOf("</p>") + 4;
    }
  
    if (articleElement.find('#article h1').text().includes("COVID") && articleElement.find('#article .category-text').text().includes("Trackers")) {
      if (adunit.includes('2')) return;
      articleElement.find('a:contains("news@raps.org")').next().next().next().after($(adunit));
      return;
    }

    if (articleElement.find(".instagram-media").length > 0 && adunit.includes('2')) return;
  
    if (adunit.includes('2') && mid < 4700) {
      let offset = 100;
      mid = content.length - offset + content.substring(content.length - offset, content.length).indexOf("\n") + 1;
    }
  
    articleElement.html(
      content.substring(0, mid) +
      $(adunit).prop('outerHTML') +
      content.substring(mid));

    adunit = adunit.replace('#adcontentbannersdiv ', '')
      
    if ($(adunit).parent('li').length > 0) {
      $(adunit).parent('li').parent().after($(adunit));
    }
    else if ($(adunit).prev('li').length > 0) {
      $(adunit).parent().after($(adunit));
    }

    console.log("|"+adunit +"|")
    console.log($(adunit).parent('a').length)

    if ($(adunit).parent('a').length > 0) {
      $(adunit).parent('a').after($(adunit));
    }
  
    if (((articleElement.find('.category-text').text() == 'Feature Articles') || (articleElement.find('.category-text').text() == 'RF Quarterly')) && articleElement.find(adunit).prevUntil('.figure img', 'br').length < 5 || $(adunit).prev('.figure img').length > 0) {
      let next = $(adunit).next();
      for (let i = 0; i < (5 - $(adunit).prevUntil('img', 'br').length); i++)
        next = next.next();
      next.after($(adunit));
    }
  }

  return articleElement.html();
}